import { Grid } from '@material-ui/core';
import { TextField } from '@roc/ui';

export type TrackingNumberProps = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export const TrackingNumber = (props: TrackingNumberProps) => {
  const { value, onChange, disabled } = props;

  return (
    <Grid container spacing={1} justify="center">
      <Grid item xs={12}>
        <TextField
          testId="trackingNumber"
          value={value}
          fullWidth
          label={'Tracking Number'}
          variant="outlined"
          disabled={disabled}
          onChange={e => onChange(e.target.value)}
        />
      </Grid>
    </Grid>
  );
};

export default TrackingNumber;